import { omitDeep } from 'deepdash/standalone';
import { DataScienceOptimization, ScheduleType } from 'modules/domains/campaign';
import { GraphQLCampaign } from 'modules/campaigns/lib/types';
import { getHasSendTimeOptimization } from '../../utils';

/**
 * Generates "send campaign now" payload
 */
export const getSendCampaignPayload = (campaign: GraphQLCampaign, projectTimeZone: string) => {
  const {
    id,
    customQuietHours,
    customRateLimit,
    schedulerMsgParams,
    dataScienceOptimizations,
    mobileAppIds,
  } = campaign;

  const isSTOEnabled = getHasSendTimeOptimization(campaign);

  const stoData = {
    dataScienceOptimizations,
    windowHours: schedulerMsgParams?.windowHours,
    scheduleType: DataScienceOptimization.SendTimeOptimization,
    automaticSendTime: !!schedulerMsgParams?.automaticSendTime || isSTOEnabled,
  };

  const payload = {
    campaignId: id,
    startTime: null,
    customRateLimit: customRateLimit ?? null,
    customQuietHours: customQuietHours ?? null,
    mobileAppIds: mobileAppIds ?? [],
    /**
     * Note: it's important that we set the scheduleType and timezone fields.
     * For cloned campaigns, those values may have been set in cloned campaign and would stick around.
     * We want to make sure to overwrite it. */
    scheduleType: ScheduleType.ProjectTimeZone,
    startTimeZone: projectTimeZone,
    defaultTimeZone: projectTimeZone,
    ...(isSTOEnabled && stoData),
  };

  return omitDeep(payload, ['__typename']);
};
